export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11032.7a335c24.jpg";